// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3eMNV","spinner":"styles_spinner__2ec8c","spin":"styles_spin__30lth"};